import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import './App.css';
import AutoComplete from 'material-ui/AutoComplete';
import IconButton from 'material-ui/IconButton';
import ActionSearch from 'material-ui/svg-icons/action/search';
import Common from './Common';
import NavigationClose from 'material-ui/svg-icons/navigation/close';

const styles = {
  largeIcon: {
    width: 30,
    height: 30
  },
  large: {
    width: 40,
    height: 40,
    padding: 5
  },
  smallIcon: {
    width: 24,
    height: 24,
    fill: '#535353'
  },
  small: {
    width: 30,
    height: 30,
    padding: 3
  },
  smallExtraLeft: {
    width: 30,
    height: 30,
    padding: 3,
    marginLeft:16
  },
  smallExtraLeftMobile: {
    width: 30,
    height: 30,
    padding: 3,
    marginLeft:8
  },
};

class MainToolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      splitLogo:'',
      dataAutoCompelte: [],
    };
    this.props.parent.mainToolbar = this;
    //this.setAutoComplete();
  }

  setAutoComplete() {
    var self = this;
    Common.getDataFromService({
      funct: 'getAuthor',
      site: window.localStorage.getItem("lang")
    }).then(function(data) {
        var result = [];
        self.authorList = data;
        data.forEach((obj) => {
          result.push(obj.title);
        });
        self.setState({
          dataAutoCompelte: result
        });
      });
  }

  handleUpdateInput(textInput) {
    this.setState({
      searchText: textInput
    });
    if (this.state.dataAutoCompelte.indexOf(textInput) !== -1) {
      this.props.parent.actionSearch(textInput, 'person').then(() => {});
    }
  }

  keyInput(ev) {
    if (ev.key === 'Enter') {
      this.props.parent.actionSearch(this.state.searchText).then(() => {});
      ev.preventDefault();
      ev.target.blur();
    }
  }

  touchSearch() {
    this.props.parent.actionSearch(this.state.searchText).then(() => {});
  }

  clearSearch(onlyText) {
    this.handleUpdateInput('');
    if (onlyText !== true)
      this.props.parent.actionSearch('').then(() => {});
  }

  goHome() {
    this.setState({
      searchText: ''
    });
    setTimeout(() => {
      this.props.parent.mediaControl.audioEnd();
      setTimeout(() => {
        this.props.parent.actionSearch('');
      }, 300);
    }, 300);
  }

  changeLang(lang) {
    localStorage.setItem("lang", lang);
    this.handleUpdateInput('');
    this.props.parent.dataSource = {};
    this.props.parent.setState({ searchResults:[] });
    setTimeout(() => {
      this.props.parent.actionSearch('').then(() => {});
    }, 300);
    this.setAutoComplete();
    this.props.parent.setLikeAndPlayList();
  }

  setSpinLogo(status) {
    if (status) {
      this.setState({
        splitLogo:''
        // splitLogo:'App-logo'
      });
    }
    else {
      this.setState({
        splitLogo:''
      });
    }
  }

  render() {
    var searchHint = '';
    var langButton =  () => {
      var selectedStyle = {color:'#FF9800', cursor:'pointer'};
      var normalStyle = {color:'#535353', cursor:'pointer'};
      var marginLeft = 24;
      if (Common.isMobile()) {
        marginLeft = 8;
      }
      return (
        <table style={{color:'#000', display: 'inline-block', fontSize:'15px', lineHeight:'15px', marginLeft:marginLeft}}>
          <tbody><tr>
            <td><div style={localStorage.getItem("lang") === 'TH' ? selectedStyle : normalStyle} onClick={this.changeLang.bind(this, 'TH')}>ไทย</div></td>
            <td>&nbsp;|&nbsp;</td>
            <td><div style={localStorage.getItem("lang") === 'EN' ? selectedStyle : normalStyle} onClick={this.changeLang.bind(this, 'EN')}>Eng</div></td>
          </tr></tbody>
        </table>
      );
    }
    if (Common.isMobile()) {
      let iconImage = process.env.PUBLIC_URL + '/images/icon.png';
      searchHint = localStorage.getItem("lang") === 'TH' ? 'ค้นหา' : searchHint;
      searchHint = localStorage.getItem("lang") === 'EN' ? 'Search' : searchHint;

      return <AppBar title={
        <table width="100%">
          <tbody>
          <tr>
            { this.state.searchText.length > 0 ?
              <td width="0" style={{color:'#555', fontSize:20, textAlign:'left'}}>&nbsp;</td>
              :
              <td width="44" style={{color:'#555', fontSize:20, textAlign:'left'}}><img alt="" src={iconImage} style={{width:44, position:'absolute', marginTop:-19, marginLeft:-12}} className={this.state.splitLogo} /></td>
            }
            <td>
              <div style={{marginTop:-8}}>
                <AutoComplete
                    menuProps={{menuItemStyle:{fontSize:13}}}
                    popoverProps={{style:{width:290}}}
                    searchText={this.state.searchText}
                    hintText={searchHint}
                    dataSource={this.state.dataAutoCompelte}
                    ref='searchField'
                    onUpdateInput={this.handleUpdateInput.bind(this)}
                    onKeyPress={this.keyInput.bind(this)}
                    fullWidth={true}
                />
              </div>
            </td>
            <td width="60">
              <div style={{ marginTop:-25, height:30}}>
                <IconButton style={this.state.searchText.length > 0 ? styles.small: {display: 'none'}} iconStyle={styles.smallIcon} onTouchTap={this.clearSearch.bind(this)}>
                  <NavigationClose />
                </IconButton>
                <IconButton style={styles.small} iconStyle={styles.smallIcon} onTouchTap={this.touchSearch.bind(this)}>
                  <ActionSearch />
                </IconButton>
                { this.state.searchText.length > 0 ?
                  <span></span>
                  :
                  langButton()
                }
              </div>
            </td>
          </tr></tbody></table>
        } style={{backgroundColor:'#ffffff', 'position':'fixed', boxShadow:'rgba(0, 0, 0, 0.117647) 0px 1px 2px, rgba(0, 0, 0, 0.117647) 0px 1px 2px'}} iconStyleLeft={{'display':'none'}}>
        </AppBar>
    }
    else {
      searchHint = localStorage.getItem("lang") === 'TH' ? 'ค้นหา เช่น ดับทุกข์ยังไง ความสุขคืออะไร วิธีเลี้ยงลูก ...' : searchHint;
      searchHint = localStorage.getItem("lang") === 'EN' ? 'Search' : searchHint;
      let iconImage = process.env.PUBLIC_URL + '/images/icon.png';
      return (
        <AppBar title={
          <table width="100%">
            <tbody>
            <tr width="100%">
              <td width="215" style={{color:'#555'}}><img alt="" src={iconImage} style={{width:40, position:'absolute', marginTop:10}} className={this.state.splitLogo} /><div style={{marginLeft:50}}>DhammaLife</div></td>
              <td width="410">
                <div style={{marginTop:-8, width:400}}>
                  <AutoComplete
                      searchText={this.state.searchText}
                      hintText={searchHint}
                      dataSource={this.state.dataAutoCompelte}
                      ref='searchField'
                      onUpdateInput={this.handleUpdateInput.bind(this)}
                      onKeyPress={this.keyInput.bind(this)}
                      fullWidth={true}
                  />
                </div>
              </td>
              <td>
                <div style={{marginTop:-15, height:40}}>
                  <IconButton style={this.state.searchText.length > 0 ? styles.small: {display: 'none'}} iconStyle={styles.smallIcon} onTouchTap={this.clearSearch.bind(this)}>
                    <NavigationClose />
                  </IconButton>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <IconButton style={styles.small} iconStyle={styles.smallIcon} onTouchTap={this.touchSearch.bind(this)}>
                    <ActionSearch />
                  </IconButton>
                  {langButton()}
                </div>
              </td>
            </tr></tbody></table>} showMenuIconButton={false} style={{backgroundColor:'#ffffff', 'position':'fixed', boxShadow:'rgba(0, 0, 0, 0.117647) 0px 1px 2px, rgba(0, 0, 0, 0.117647) 0px 1px 2px'}}>
          </AppBar>
      );
    }
  }
}

export default MainToolbar;



// WEBPACK FOOTER //
// ./src/MainToolbar.js